/**
 * General LCG responsive related functionality
 *
 * @author Andrew Jackson (ajackson@lyonscg.com)
 * @author Ryan Hutchinson (rhutchinson@lyonscg.com)
 */
 'use strict';
/* eslint-disable */

var lcg_responsive = {
	data: {
		tabItems: '.tabs-menu > li',
		tabAttr: 'aria-controls',
		tabElementId: '-mobile-content',
		tabRollbackDest: '.tab-desktop-content',
		tabHtmlId: '#',
		tabHtmlClass: '.'
	},
	/**
	 * Relocate the given element to the given destination using the given method.
	 *
	 * Also accepts a rollback destination for back functionality
	 * and dynamic width check for multiple viewport support.
	 *
	 * width === null -- disables the back functionality.
	 *
	 * @param int 		width (optional)
	 * @param obj 		element
	 * @param string 	destination
	 * @param string 	roll_back_destination (optional)
	 * @param string	move_type (optional)
	 * @return 			VOID
	 */
	move: function (width, element, destination, roll_back_destination, move_type) {
		var check = this.checkWidth (width);

		if (move_type === undefined) {
			move_type = 'appendTo';
		}

		if (check) {
			if (jQuery(element) !== undefined && jQuery(destination) !== undefined) {
				jQuery(element)[move_type](destination);
			}
		} else {
			if (jQuery(element) !== undefined && jQuery(destination) !== undefined && jQuery(roll_back_destination) !== undefined) {
				jQuery(element)[move_type](roll_back_destination);
			}
		}

		return;
	},

	/**
	 * Add or remove given class on given element based on width
	 *
	 * If width is greater than or equal to document.width, class is added
	 * otherwise class is removed.
	 *
	 * Also offers callback for both true and false results with param support.
	 * (Useful for initializing things based on class)
	 *
	 * @param int 		width
	 * @param string 	element
	 * @param string 	class_name
	 * @param string 	call_back_true (optional)
	 * @param string 	call_back_false (optional)
	 * @param mixed 	args (optional)
	 * @var bool 		check
	 * @var array 		call_back
	 * @return VOID
	 */
	toggleClass: function (width, element, class_name, call_back_true, call_back_false, args) {
		var check = this.checkWidth(width),
			call_back;

		if (check) {
			jQuery(element).addClass(class_name);

			if (call_back_true !== undefined) {
				call_back = call_back_true.split('.');
				this.callBack(call_back, args);
			}
		} else {
			if (call_back_false !== undefined) {
				call_back = call_back_false.split('.');
				this.callBack(call_back, args);
			}

			jQuery(element).removeClass(class_name);
		}

		return;
	},

	/**
	 * Checks if the document width is less than or equal to given width.
	 * If it is, true
	 * If it is not, false
	 *
	 * @param int 	width
	 * @var bool 	check
	 * @return bool
	 */
	checkWidth: function (width) {
		var check = false;

		if (width === null || width == true) {
			check = true;
		}

		return check;
	},

	/**
	 * Creates dynamic containers with ids matching the number of tabs.
	 * Checks to see if appended containers are empty. Populates containers
	 * Activates move method with dynamic params
	 *
	 * @method tabAccordMobile
	 * @param {String} tabRollbackDest
	 * @param {String} tabHtmlClass
	 * @param {String} tabHtmlId
	 * @param {String} tabAttr
	 * @param {String} tabElementId
	 * @var {String} tabItems
	 * @return VOID
	 */
	tabAccordMobile: function (width) {
		$(lcg_responsive.data.tabItems).each(function () {
			var tabId = $(this).attr(lcg_responsive.data.tabAttr);
			if ($(lcg_responsive.data.tabHtmlClass + tabId + lcg_responsive.data.tabElementId).length > 0) {
				lcg_responsive.move(
					width,
					lcg_responsive.data.tabHtmlId + tabId,
					lcg_responsive.data.tabHtmlClass + tabId + lcg_responsive.data.tabElementId,
					lcg_responsive.data.tabRollbackDest
				);
			} else {
				$(this).append('<div class="' + tabId + lcg_responsive.data.tabElementId + '"></div>');
				lcg_responsive.move(
					width,
					lcg_responsive.data.tabHtmlId + tabId,
					lcg_responsive.data.tabHtmlClass + tabId + lcg_responsive.data.tabElementId,
					lcg_responsive.data.tabRollbackDest
				);
			}
		});

		$('.tab-target-mobile .ui-tabs-anchor').on('click', function () {
			var headerHeight = $('.stuckMenu').height();
			var target = $(this).parent();
			$('html, body').scrollTop($(target).offset().top - headerHeight);
		});

	},

	/**
	 * Runs a call back method in any given object and passes along
	 * given parameters as any data type.
	 *
	 * @param array call_back
	 * @param mixed args (optional)
	 * @return VOID
	 */
	callBack: function (call_back, args) {
		if (args === undefined) {
			var args = '';
		}

		window[ call_back[0] ][ call_back[1] ](args);

		return;
	}
};

module.exports = lcg_responsive;
